export const messages = {
  en: {
    applyReturnOrder: {
      title: 'Return Goods',
      selectOrderGoods: 'Select Order Goods',
      type: 'Type',
      orderId: 'Order ID',
      name: 'Name',
      user: 'User',
      purchaseQuantity: 'Purchase Quantity',
      paymentAmount: 'Payment Amount',
      returnQuantity: 'Return Quantity',
      unitPrice: 'Unit Price',
      operation: 'Operation',
      delete: 'Delete',
      description: 'Description',
      totalAmount: 'Total Amount',
      returnRemark: 'Return Remark',
      remarkPlaceholder: 'Required, please fill in the return description',
      cancel: 'Cancel',
      submit: 'Submit'
    }
  },
  zh: {
    applyReturnOrder: {
      title: '退货商品',
      selectOrderGoods: '选择订单商品',
      type: '类型',
      orderId: '订单编号',
      name: '名称',
      user: '用户',
      purchaseQuantity: '购买数量',
      paymentAmount: '支付金额',
      returnQuantity: '退货数量',
      unitPrice: '单价',
      operation: '操作',
      delete: '删除',
      description: '说明',
      totalAmount: '总金额',
      returnRemark: '退货说明',
      remarkPlaceholder: '必填，请填写退货说明',
      cancel: '取消',
      submit: '提交'
    }
  }
}